var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuperadminDashboardItemPendingRequestsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.905,
    height: 40.905,
    viewBox: "0 0 40.905 40.905",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape",
    "data-name": "Combined Shape",
    d: "M3.152,31.583A21.188,21.188,0,0,1,4.692,7.165,19,19,0,0,1,27.526,1.772a1.893,1.893,0,0,1,.9,2.455,1.75,1.75,0,0,1-2.348.942A15.537,15.537,0,0,0,7.4,9.581,17.336,17.336,0,0,0,6.135,29.56,15.674,15.674,0,0,0,24.1,36.5,16.649,16.649,0,0,0,35.569,20.462V18.734a1.781,1.781,0,1,1,3.558,0v1.73a20.354,20.354,0,0,1-14.017,19.6,18.751,18.751,0,0,1-5.547.841A19.366,19.366,0,0,1,3.152,31.583ZM18.306,25.5,12.97,19.919a1.921,1.921,0,0,1,0-2.63,1.728,1.728,0,0,1,2.516,0l4.077,4.264L37.869,2.416a1.723,1.723,0,0,1,2.515,0,1.918,1.918,0,0,1,0,2.629L20.821,25.5a1.723,1.723,0,0,1-2.515,0Z",
    transform: "translate(0 0)",
    fill: "#199b8b"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuperadminDashboardItemPendingRequestsIcon);
export default __webpack_public_path__ + "static/media/superadmin-dashboard-item-pending-requests-icon.c8a2c841c573d09c80178f6f592a6bc9.svg";
export { ForwardRef as ReactComponent };